
  import Vue from 'vue'
  import { Prop, Component, Watch } from 'vue-property-decorator'
  import ListTable from './List/Table.vue'
  import { ListAction, ListColumn, ListOptions } from '../../global/components/List/Table.vue'
  import FavouritesManager, {ListFilter, ListSetting} from '../../global/components/List/favourites'

  @Component({
    components: { ListTable }
  })
  export default class SimpleList<T> extends Vue {
    @Prop({ type: String, required: true })
    private readonly favouritesKey!: string

    @Prop({ type: String, required: true })
    private readonly route!: string

    @Prop({ type: Array, default: () => [] })
    private readonly headers!: ListColumn<T>[]

    @Prop({ type: Array, default: () => [] })
    private readonly columns!: (keyof T)[]

    @Prop({ type: Array, default: () => [] })
    private readonly filters!: ListFilter[]

    @Prop({ type: Array, default: () => [] })
    private readonly actions!: ListAction<T>[]

    get table() {
      return this.$refs.table as ListTable<T>
    }

    configuring = false

    isReady = false

    options: ListOptions = {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    }

    @Watch('options', { deep: true })
    private optionsChanged(value: ListOptions) {
      this.setSetting()
      this.updateResults(value)
    }

    mounted() {
      this.configureFavourites()
    }

    updateResults(options?: ListOptions) {
      if (this.isReady) {
        this.table.updateResults(options)
      }
    }

    private setSetting() {
      FavouritesManager.setSetting(this.favouritesKey, {
        sortByField: this.options.sortBy[0],
        sortByOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC',
        columns: this.columns as string[],
        filters: this.filters,
        itemsPerPage: this.options.itemsPerPage
      })
    }

    private configureFavourites() {
      const existingSetting = FavouritesManager.checkSetting(this.favouritesKey)
      if (existingSetting) {
        this.configureSettings(existingSetting)
      }
      this.isReady = true
    }

    private configureSettings(setting: ListSetting) {
      this.configuring = true
      try {
        this.options.sortBy = [setting.sortByField]
        this.options.sortDesc = [setting.sortByOrder === 'DESC']
        this.options.itemsPerPage = setting.itemsPerPage || 10
      } finally {
        this.configuring = false
      }
    }
  }
